import { Team__Adrianes } from "../teams/Adrianes";
import { Team__Cerveceros_2 } from "../teams/Cerveceros_2";
import { Team__Joeles } from "../teams/Joeles";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Lorenas } from "../teams/Lorenas";
import { Team__LosQuintanas } from "../teams/LosQuintanas";
import { Team__Natalias } from "../teams/Natalias";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Potros } from "../teams/Potros";
import { Team__Pythons } from "../teams/Pythons";
import { Team__RoadRunner } from "../teams/RoadRunner";
import { Team__RWE } from "../teams/RWE";
import { Team__Wolfpack } from "../teams/Wolfpack";

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_2,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 31,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Lorenas = {
  team: Team__Lorenas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const LosQuintanas = {
  team: Team__LosQuintanas,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 43,
  penaltyGoals: 0,
  isWinner: false,
};

const RoadRunner = {
  team: Team__RoadRunner,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const RWE = {
  team: Team__RWE,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Wolfpack = {
  team: Team__Wolfpack,
  playingPlayers: [],

  goals: 37,
  penaltyGoals: 0,
  isWinner: false,
};

// =========================
// =========================
// =========================

const GroupWinner1 = {
  team: {
    name: "1st Place",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const GroupWinner2 = {
  team: {
    name: "2nd Place",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const GroupWinner3 = {
  team: {
    name: "3rd Place",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Best2ndPlace = {
  team: {
    name: "Best 2nd place team",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Joeles,
      team2: Pythons,

      isCompleted: true,
      isPlaying: true,
      day: "Viernes",
      date: "2025-08-01",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Wolfpack,
      team2: Natalias,

      isCompleted: true,
      isPlaying: true,
      day: "Viernes",
      date: "2025-08-01",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
